import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActasAdminService } from "../actas.service";
import { MyErrorStateMatcher, RequireMatch } from "src/app/utils/requireMatch";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { CajaModalComponent } from "../../caja/modal/modal.component";
import * as dayjs from "dayjs";
import {
  NgxImageCompressFormat,
  NgxImageCompressService,
} from "ngx-image-compress";
import dataURItoBlob from "src/app/utils/dataURItoBlob";

@Component({
  selector: "app-form-actas",
  templateUrl: "./form.component.html",
})
export class ActasAdminForm implements OnInit {
  public form: FormGroup;
  public formCombustible: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;
  public generarCargo = false;
  public generarCarta = false;

  public generarCargoComb = false;
  public generarCartaComb = false;
  public openTab = 1;

  @Input("list") list: any[];
  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    type: number;
  }>();

  filteredOptions: Observable<any[]>;
  matcher = new MyErrorStateMatcher();
  listUni: any[] = [];
  listRec: any[] = [];

  filteredOptionsComb: Observable<any[]>;
  matcherComb = new MyErrorStateMatcher();
  listUniComb: any[] = [];
  listRecComb: any[] = [];

  public fileList: File[] = [];
  public imagesList: any[] = [];

  public fileListComb: File[] = [];
  public imagesListComb: any[] = [];
  constructor(
    private fb: FormBuilder,
    public service: ActasAdminService,
    private imageCompress: NgxImageCompressService,
  ) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.generarCargo = false;
    this.generarCarta = false;
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.restartFormNormal();
    this.restartFormCombustible();
  }
  restartFormNormal() {
    this.imagesList = [];
    this.fileList = [];
    this.generarCargo = false;
    this.generarCarta = false;
    this.form.reset();
    this.form.controls["Chofer"].enable();
    this.form.controls["Puesto"].enable();
    this.form.controls["Hechos"].enable();
    this.form.controls["Manifesto"].enable();
    this.form.controls["Sancion"].enable();
    this.form.controls["Testigo1"].enable();
    this.form.controls["Testigo2"].enable();
    this.form.controls["CargoCaja"].enable();
    this.form.controls["FechaDeActa"].enable();
    this.form.controls["HoraDeActa"].enable();
    this.form.controls["FechaDeActa"].patchValue(dayjs().format("YYYY-MM-DD"));
    this.form.controls["HoraDeActa"].patchValue(dayjs().format("hh:mm"));
    this.form.controls["IdUnidad"].enable();
    this.form.controls["IdRecepcion"].enable();
    this.form.controls["IdUnidad"].patchValue("");
    this.form.controls["IdRecepcion"].patchValue("");
  }
  restartFormCombustible() {
    this.imagesListComb = [];
    this.fileListComb = [];
    this.generarCargoComb = false;
    this.generarCargoComb = false;
    this.formCombustible.reset();
    this.formCombustible.controls["Chofer"].enable();
    this.formCombustible.controls["Puesto"].enable();
    this.formCombustible.controls["Manifesto"].enable();
    this.formCombustible.controls["Testigo1"].enable();
    this.formCombustible.controls["Testigo2"].enable();
    this.formCombustible.controls["CargoCaja"].enable();
    this.formCombustible.controls["FechaDeActa"].enable();
    this.formCombustible.controls["FechaSuceso"].enable();
    this.formCombustible.controls["HoraDeActa"].enable();
    this.formCombustible.controls["FechaDeActa"].patchValue(
      dayjs().format("YYYY-MM-DD"),
    );
    this.formCombustible.controls["FechaSuceso"].patchValue(
      dayjs().format("YYYY-MM-DD"),
    );
    this.formCombustible.controls["HoraDeActa"].patchValue(
      dayjs().format("hh:mm"),
    );
    this.formCombustible.controls["IdUnidad"].enable();
    this.formCombustible.controls["IdRecepcion"].enable();
    this.formCombustible.controls["IdUnidad"].patchValue("");
    this.formCombustible.controls["IdRecepcion"].patchValue("");
    this.formCombustible.controls["CombustibleSacado"].enable();
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;
    if (this.defaults?.PorCombustible) {
      this.openTab = 2;
      this.fillFormCombustible(this.defaults);
    } else {
      this.openTab = 1;
      this.fillFormNormal(this.defaults);
    }
    this.loadImages(this.defaults.IdActaAdministrativa);
  }
  loadImages(id: any) {
    this.service.getPhothos(id).subscribe(
      (resultData) => {
        this.imagesList = resultData;
        this.imagesListComb = resultData;
      },
      (err) => {
        console.error("error", err.error.Message);
      },
    );
  }
  async fillFormNormal(row: any) {
    this.generarCargo = row?.CargoCaja != null;
    this.generarCarta = row?.CartaCompromiso != null;
    const chofer = this.list.find((f) => f.Id == row?.IdTrabajador);
    this.form.controls["Chofer"].patchValue(chofer);
    this.form.controls["Puesto"].patchValue(row?.Puesto);
    this.form.controls["Hechos"].patchValue(row?.Hechos);
    this.form.controls["Manifesto"].patchValue(row?.Manifesto);
    this.form.controls["Sancion"].patchValue(row?.Sancion);
    this.form.controls["Testigo1"].patchValue(row?.Testigo1);
    this.form.controls["Testigo2"].patchValue(row?.Testigo2);
    this.form.controls["CargoCaja"].patchValue(row?.CargoCaja);
    this.form.controls["CartaCompromiso"].patchValue(row?.CartaCompromiso);
    this.form.controls["FechaDeActa"].patchValue(
      row.FechaDeActa ? dayjs(row.FechaDeActa).format("YYYY-MM-DD") : null,
    );
    this.form.controls["HoraDeActa"].patchValue(
      row.FechaDeActa ? dayjs(row.FechaDeActa).format("hh:mm") : null,
    );
    this.form.controls["Chofer"].disable();
    this.form.controls["Puesto"].disable();
    this.form.controls["Hechos"].disable();
    this.form.controls["Manifesto"].disable();
    this.form.controls["Sancion"].disable();
    this.form.controls["Testigo1"].disable();
    this.form.controls["Testigo2"].disable();
    this.form.controls["CargoCaja"].disable();
    this.form.controls["FechaDeActa"].disable();
    this.form.controls["HoraDeActa"].disable();
    await this.reloadSelects(row?.IdTrabajador);
  }
  async fillFormCombustible(row: any) {
    this.generarCargoComb = row?.CargoCaja != null;
    this.generarCartaComb = row?.CartaCompromiso != null;
    const chofer = this.list.find((f) => f.Id == row?.IdTrabajador);
    this.formCombustible.controls["CargoCaja"].patchValue(row?.CargoCaja);
    this.formCombustible.controls["CartaCompromiso"].patchValue(
      row?.CartaCompromiso,
    );
    this.formCombustible.controls["Chofer"].patchValue(chofer);
    this.formCombustible.controls["CombustibleSacado"].patchValue(
      row?.CombustibleSacado,
    );
    this.formCombustible.controls["FechaDeActa"].patchValue(
      row.FechaDeActa ? dayjs(row.FechaDeActa).format("YYYY-MM-DD") : null,
    );
    this.formCombustible.controls["FechaSuceso"].patchValue(
      row.FechaSuceso ? dayjs(row.FechaSuceso).format("YYYY-MM-DD") : null,
    );
    this.formCombustible.controls["HoraDeActa"].patchValue(
      row.FechaDeActa ? dayjs(row.FechaDeActa).format("hh:mm") : null,
    );
    this.formCombustible.controls["Manifesto"].patchValue(row?.Manifesto);
    this.formCombustible.controls["Puesto"].patchValue(row?.Puesto);
    this.formCombustible.controls["Testigo1"].patchValue(row?.Testigo1);
    this.formCombustible.controls["Testigo2"].patchValue(row?.Testigo2);
    this.formCombustible.controls["Chofer"].disable();
    this.formCombustible.controls["Puesto"].disable();
    this.formCombustible.controls["Manifesto"].disable();
    this.formCombustible.controls["Testigo1"].disable();
    this.formCombustible.controls["Testigo2"].disable();
    this.formCombustible.controls["CargoCaja"].disable();
    this.formCombustible.controls["FechaDeActa"].disable();
    this.formCombustible.controls["HoraDeActa"].disable();
    this.formCombustible.controls["CombustibleSacado"].disable();
    this.formCombustible.controls["FechaSuceso"].disable();
    await this.reloadSelectsComb(row?.IdTrabajador);
  }
  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    if (this.openTab == 1) {
      const dataForm = this.form.value;

      const data = {
        ...dataForm,
        IdTrabajador: dataForm.Chofer.Id,
        FechaDeActa: dataForm.FechaDeActa + " " + dataForm.HoraDeActa,
        files: this.fileList,
      };
      this.onsave.emit({
        mode: this.mode,
        value: data,
        type: 1,
      });
    } else {
      const dataForm = this.formCombustible.value;

      const data = {
        ...dataForm,
        IdTrabajador: dataForm.Chofer.Id,
        FechaDeActa: dataForm.FechaDeActa + " " + dataForm.HoraDeActa,
        files: this.fileListComb,
      };
      this.onsave.emit({
        mode: this.mode,
        value: data,
        type: 2,
      });
    }
  }

  public update() {
    const dataForm = this.form.value;
    const data = { ...dataForm, IdTrabajador: dataForm.Chofer.Id };
    this.onsave.emit({
      mode: this.mode,
      value: data,
      type: 1,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  private buildForm() {
    this.buildFormNormal();
    this.buildFormCombustible();
  }
  buildFormNormal() {
    this.form = this.fb.group({
      Puesto: ["", [Validators.required]],
      Hechos: ["", [Validators.required]],
      Manifesto: ["", [Validators.required]],
      Sancion: [""],
      Testigo1: ["", [Validators.required]],
      Testigo2: ["", [Validators.required]],
      CargoCaja: [""],
      Chofer: new FormControl("", [Validators.required, RequireMatch]),
      FechaDeActa: ["", [Validators.required]],
      HoraDeActa: ["", [Validators.required]],
      CartaCompromiso: [""],
      IdUnidad: [""],
      IdRecepcion: [""],
    });
    if (this.mode != "update") {
      this.filteredOptions = this.form.controls["Chofer"].valueChanges.pipe(
        startWith(""),
        map((value) => this._filter(value)),
      );

      this.form.controls["Chofer"].valueChanges.subscribe((value) => {
        if (value == undefined || value == null) return;
        if (typeof value === "string") return;
        this.reloadSelects(value.Id);
      });
    }
  }
  buildFormCombustible() {
    this.formCombustible = this.fb.group({
      Puesto: ["", [Validators.required]],
      Manifesto: ["", [Validators.required]],
      Testigo1: ["", [Validators.required]],
      Testigo2: ["", [Validators.required]],
      CargoCaja: [""],
      CombustibleSacado: ["", [Validators.required]],
      Chofer: new FormControl("", [Validators.required, RequireMatch]),
      FechaDeActa: ["", [Validators.required]],
      HoraDeActa: ["", [Validators.required]],
      FechaSuceso: ["", [Validators.required]],
      CartaCompromiso: [""],
      IdUnidad: [""],
      IdRecepcion: [""],
    });
    if (this.mode != "update") {
      this.filteredOptionsComb = this.formCombustible.controls[
        "Chofer"
      ].valueChanges.pipe(
        startWith(""),
        map((value) => this._filterComb(value)),
      );

      this.formCombustible.controls["Chofer"].valueChanges.subscribe(
        (value) => {
          if (value == undefined || value == null) return;
          if (typeof value === "string") return;
          this.reloadSelectsComb(value.Id);
        },
      );
    }
  }

  reloadSelects(id: any) {
    this.service.getHistorialChofer(id).subscribe(
      (resultData) => {
        this.listRec = resultData
          .map((m) => {
            return {
              Id: m.IdRecepcion,
              Desc:
                m.Folio + " - " + dayjs(m.FechaCreacion).format("YYYY-MM-DD"),
            };
          })
          .filter(onlyUnique);
        this.listUni = resultData
          .map((m) => {
            return { Id: m.IdUnidad, Desc: m.NoControl + " - " + m.Placas };
          })
          .filter(onlyUnique);

        if (this.mode == "update") {
          this.form.controls["IdUnidad"].patchValue(
            this.defaults?.IdUnidad ?? "",
          );
          this.form.controls["IdRecepcion"].patchValue(
            this.defaults?.IdRecepcion ?? "",
          );
          this.form.controls["IdUnidad"].disable();
          this.form.controls["IdRecepcion"].disable();
        } else {
          this.form.controls["IdUnidad"].patchValue("");
          this.form.controls["IdRecepcion"].patchValue("");
        }
      },
      (err) => {
        console.error("error", err.error.Message);
      },
    );
  }

  reloadSelectsComb(id: any) {
    this.service.getHistorialChofer(id).subscribe(
      (resultData) => {
        this.listRecComb = resultData
          .map((m) => {
            return {
              Id: m.IdRecepcion,
              Desc:
                m.Folio + " - " + dayjs(m.FechaCreacion).format("YYYY-MM-DD"),
            };
          })
          .filter(onlyUnique);
        this.listUniComb = resultData
          .map((m) => {
            return { Id: m.IdUnidad, Desc: m.NoControl + " - " + m.Placas };
          })
          .filter(onlyUnique);

        if (this.mode == "update") {
          this.formCombustible.controls["IdUnidad"].patchValue(
            this.defaults?.IdUnidad ?? "",
          );
          this.formCombustible.controls["IdRecepcion"].patchValue(
            this.defaults?.IdRecepcion ?? "",
          );
          this.formCombustible.controls["IdUnidad"].disable();
          this.formCombustible.controls["IdRecepcion"].disable();
        } else {
          this.formCombustible.controls["IdUnidad"].patchValue("");
          this.formCombustible.controls["IdRecepcion"].patchValue("");
        }
      },
      (err) => {
        console.error("error", err.error.Message);
      },
    );
  }
  displayWith(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  displayWithComb(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filter(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.list.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue),
    );
  }

  private _filterComb(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.list.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue),
    );
  }

  toggleTabs($tabNumber: number) {
    if (this.mode != "create") return;
    this.openTab = $tabNumber;
  }

  public getFile() {
    this.imageCompress
      .uploadMultipleFiles()
      .then((arrayOfFiles: NgxImageCompressFormat[]) => {
        for (let index = 0; index < arrayOfFiles.length; index++) {
          const element = arrayOfFiles[index];
          this.imageCompress
            .compressFile(element.image, element.orientation, 50, 50) // 50% ratio, 50% quality
            .then((compressedImage) => {
              const blob = dataURItoBlob(compressedImage);
              this.imagesList.push(compressedImage);
              this.fileList.push(
                new File([blob], "Imagen" + new Date().getTime().toString(16)),
              );
            });
        }
      });
  }
  public removeImage(src) {
    const inx = this.imagesList.findIndex((f) => f == src);
    this.imagesList.splice(inx, 1);
    this.fileList.splice(inx, 1);
  }

  public getFileComb() {
    this.imageCompress
      .uploadMultipleFiles()
      .then((arrayOfFiles: NgxImageCompressFormat[]) => {
        for (let index = 0; index < arrayOfFiles.length; index++) {
          const element = arrayOfFiles[index];
          this.imageCompress
            .compressFile(element.image, element.orientation, 50, 50) // 50% ratio, 50% quality
            .then((compressedImage) => {
              const blob = dataURItoBlob(compressedImage);
              this.imagesListComb.push(compressedImage);
              this.fileListComb.push(
                new File([blob], "Imagen" + new Date().getTime().toString(16)),
              );
            });
        }
      });
  }
  public removeImageComb(src) {
    const inx = this.imagesListComb.findIndex((f) => f == src);
    this.imagesListComb.splice(inx, 1);
    this.fileListComb.splice(inx, 1);
  }
}
function onlyUnique(value, index, array) {
  return array.findIndex((f) => f.Id == value.Id) === index;
}
